import { Data } from './Data';
import { DataSkeleton } from './DataSkeleton';
import { Header } from './Header';

export const StrikeCell = { Data, Header, DataSkeleton };
